<!-- <div class="alert-container">
  <div *ngFor="let alert of alerts" [@slideInOut] class="alert alert-{{alert.type}} alert-dismissible fade show">
    <ng-container *ngIf="isLoginRequiredAlert(alert.message) || isAddedToCartAlert(alert.message) ; else regularAlert">
      // || isUpdatedCartAlert(alert.message)
      <span *ngIf="isLoginRequiredAlert(alert.message)">You must be logged in or <a style="text-decoration: underline;cursor: pointer;" (click)="enableGuestMode()">continue as a guest</a></span>
      <span *ngIf="isAddedToCartAlert(alert.message)">Added to <a style="text-decoration: underline;cursor: pointer;" (click)="goToCart()">cart</a></span>
      //<span *ngIf="isUpdatedCartAlert(alert.message)">{{ alert.message }} <a style="text-decoration: underline;cursor: pointer;" (click)="goToCart()">Cart</a></span>
    </ng-container>
    <ng-template #regularAlert>
      {{ alert.message }}
    </ng-template>
    <button type="button" class="btn-close" (click)="remove(alert.id)"></button>
  </div>
</div> -->

<div class="alert-container">
  <div *ngFor="let alert of alerts" [@slideInOut] class="toast toast-{{alert.type}}">
    <div class="toast-icon">{{ getToastIcon(alert.type) }}</div>
    <div class="toast-content">
      <div class="toast-title">{{ getToastTitle(alert.type) }}</div>
      <div class="toast-message">
        <ng-container *ngIf="isLoginRequiredAlert(alert.message) || isAddedToCartAlert(alert.message); else regularAlert">
          <span *ngIf="isLoginRequiredAlert(alert.message)">
            You must be logged in or <a class="toast-link" (click)="enableGuestMode()">continue as a guest</a>
          </span>
          <span *ngIf="isAddedToCartAlert(alert.message)">
            Added to <a class="toast-link" (click)="goToCart()">cart</a>
          </span>
        </ng-container>
        <ng-template #regularAlert>
          {{ alert.message }}
        </ng-template>
      </div>
    </div>
    <button type="button" class="toast-close" (click)="remove(alert.id)">×</button>
    <div class="toast-progress">
      <div class="toast-progress-bar" [style.width.%]="100"></div>
    </div>
  </div>
</div>